import React, { useEffect, useState } from "react";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import HeadTabs from "../../globalComponents/HeadTabs/HeadTabs";
import { useDispatch, useSelector } from "react-redux";
import { TEACHER_PAYMENT_ALL_ACTIONS_TYPE } from "../../redux/actions-type";
import {
  getTeachersPaymentsPaginationAction,
  getTeachersSalaries,
} from "../../redux/actions/teacherPaymentActions";
import { useLocation } from "react-router-dom";
import TeacherPaymentData from "./components/TeacherPaymentData";
const TeachersPaymentPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { totalLength, teachersPayments, loading } = useSelector(
    (state) => state.teachersPaymentPagination
  );
  const { startDate, endDate } = useSelector((state) => state.filter);

  const { teacherSalarySearchValue } = useSelector(
    (state) => state.searchValues
  );

  const { teacherStatus } = useSelector((state) => state.teacherStatus);
  const { courseId } = useSelector((state) => state.studentStatus);
  const [role, setRole] = useState("teacher");

  let userData = JSON.parse(localStorage.getItem("userData"));
  userData =
    userData.role !== "super-admin"
      ? userData.profiles
      : JSON.parse(localStorage.getItem("userData"));

  // console.log(loading, "looooooooooooooodaaaaaaaaaaaiiiiiiiinnnnnngggg");

  const filterTeachers = () => {
    // console.log("filteeeeeeeeeer");
    dispatch({
      type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
    });

    if (location.pathname === "/teachers-payments") {
      setRole("teacher");
      dispatch(getTeachersSalaries(role, startDate, endDate));
    } else if (location.pathname === "/teachers-payments/mentors-payments") {
      setRole("mentor");
      dispatch(getTeachersSalaries(role, startDate, endDate));
    } else if (location.pathname === "/teachers-payments/teachers") {
      dispatch(
        getTeachersPaymentsPaginationAction(
          0,
          teacherSalarySearchValue,
          teacherStatus
            ? teacherStatus !== "all"
              ? teacherStatus
              : "all"
            : "all",
          "teacher",
          courseId
        )
      );
    } else {
      dispatch(
        getTeachersPaymentsPaginationAction(
          0,
          teacherSalarySearchValue,
          teacherStatus
            ? teacherStatus !== "all"
              ? teacherStatus
              : "all"
            : "all",
          role,
          courseId
        )
      );
    }
  };

  const getNextTeachers = () => {
    if (loading) return;
    // console.log("next teacherrrrrsssssssssssssss");

    if (teacherSalarySearchValue) {
      if (location.pathname === "/teachers-payments") {
        dispatch(getTeachersSalaries(role, startDate, endDate));
      } else if (location.pathname === "/teachers-payments/mentors-payments") {
        dispatch(getTeachersSalaries(role, startDate, endDate));
      } else if (
        location.pathname === "/teachers-payments/teachers" ||
        location.pathname === "/teachers-payments/mentors"
      ) {
        dispatch(
          getTeachersPaymentsPaginationAction(
            teachersPayments?.length || 0,
            teacherSalarySearchValue,
            teacherStatus
              ? teacherStatus !== "all"
                ? teacherStatus
                : "all"
              : "all",
            role,
            courseId
          )
        );
      }
    } else {
      dispatch(
        getTeachersPaymentsPaginationAction(
          teachersPayments?.length || 0,
          "",
          teacherStatus
            ? teacherStatus !== "all"
              ? teacherStatus
              : "all"
            : "all",
          role,
          courseId
        )
      );
    }
  };

  const searchData = (e) => {
    e.preventDefault();

    dispatch({
      type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
    });

    dispatch(
      getTeachersPaymentsPaginationAction(
        0,
        teacherSalarySearchValue,
        teacherStatus
          ? teacherStatus !== "all"
            ? teacherStatus
            : "all"
          : "all",
        role,
        courseId
      )
    );
  };

  useEffect(() => {
    if (location.pathname === "/teachers-payments") {
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
      });
      setRole("teacher");

      dispatch(getTeachersSalaries("teacher", startDate, endDate));
    } else if (location.pathname === "/teachers-payments/mentors-payments") {
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
      });
      setRole("mentor");
      dispatch(getTeachersSalaries("mentor", startDate, endDate));
    } else if (location.pathname === "/teachers-payments/teachers") {
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
      });

      dispatch(
        getTeachersPaymentsPaginationAction(
          0,
          teacherSalarySearchValue || "",
          "all",
          "teacher",
          courseId
        )
      );
      setRole("teacher");
    } else if (location.pathname === "/teachers-payments/mentors") {
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
      });

      dispatch(
        getTeachersPaymentsPaginationAction(
          0,
          teacherSalarySearchValue || "",
          "all",
          "mentor",
          courseId
        )
      );
      setRole("mentor");
    }

    return () => {
      dispatch({
        type: TEACHER_PAYMENT_ALL_ACTIONS_TYPE.RESET_TEACHER_PAYMENT_PAGINATION,
      });
    };
  }, [location.pathname]);

  return (
    <div className="details-page teachers-page ">
      <GlobalHead
        searchData={searchData}
        filter={filterTeachers}
        DATA_SEARCH_VALUE={"TEACHER_SALARY_SEARCH_VALUE"}
        dataSearchValues={teacherSalarySearchValue}
        statusType="teachers-payment"
        profile={"teachers-payment"}
        count={totalLength}
      />

      <HeadTabs
        firstRoute={"/teachers-payments"}
        secondRoute={"/teachers-payments/mentors-payments"}
        thirdRoute={"/teachers-payments/teachers"}
        fourthRoute={"/teachers-payments/mentors"}
        firstPathname={"Müəllimlərin əmək haqqı"}
        secondPathname={"Tyutorların əmək haqqı"}
        thirdPathname={"Müəllimlər"}
        fourthPathname={"Tyutorlar"}
      />

      <TeacherPaymentData
        getNextTeachers={getNextTeachers}
        userData={userData}
      />
    </div>
  );
};

export default TeachersPaymentPage;
